import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/reset.css'
import '@/styles/index.scss'
import registerDirective from './directive'
import { regMethod, regComponent, regGlobalProperties } from './regGlobals'
import { VueClipboard } from '@soerenmartius/vue3-clipboard'
// import copyDirective from './directive/copy'
// import '@/mock'


declare module 'vue' {
  interface ComponentCustomProperties {
    $onCopy(app: any): void
    Xinnet: any
    $store: any
    $auth: any
    $util: any
    $defaultTime: any
    $settings: any
    $container: any
  }
}

regMethod()
const app = createApp(App)
app.config.warnHandler = () => null
regComponent(app)
regGlobalProperties(app)
registerDirective(app)

app
  .use(store)
  .use(router)
  .use(Antd)
  .use(VueClipboard)
  .mount('#app')

  
// 有未完成临时任务提示
const beforeUnload = (e) => {
  if (Xinnet.taskRunning) {
    e.preventDefault()
    return true
  }
}
window.addEventListener('beforeunload', beforeUnload)